/**
 * Edit Sensing Station Form Composer
 *
 * Reuses AddSensingStationComposer for editing with initial values.
 * Submit label comes from form.yml configuration.
 */

import { AddSensingStationComposer, type AddSensingStationComposerProps } from '../addSensingStation/composer'
import type { AddSensingStationFormData } from '../addSensingStation/schema'

export type EditSensingStationComposerProps = Omit<AddSensingStationComposerProps, 'onSuccess'> & {
  initialValues: Partial<AddSensingStationFormData> // Ensure initialValues are provided for edit mode
  onSuccess?: () => void
}

export function EditSensingStationComposer(props: EditSensingStationComposerProps) {
  return (
    <AddSensingStationComposer
      {...props}
      showHeader={props.showHeader ?? true}
      submitLabel={props.submitLabel ?? 'Save Station'}
      initialValues={props.initialValues}
    />
  )
}
